import { StargateAPI } from '@atlassian/mpac-services-client';
import { hooks } from '@atlassian/mpac-utils';
export var useAvailableSites = function useAvailableSites(stargateBaseUrl, products) {
  var availableSitesPromise = function availableSitesPromise() {
    return new StargateAPI(stargateBaseUrl).marketplace.availableSites(products);
  };

  var _hooks$usePromise = hooks.usePromise(availableSitesPromise, [products, stargateBaseUrl]),
      result = _hooks$usePromise.result,
      error = _hooks$usePromise.error,
      pending = _hooks$usePromise.pending;

  return {
    availableSitesPending: pending,
    availableSitesError: error,
    availableSitesResult: result === null || result === void 0 ? void 0 : result.sites
  };
};
export var useAppInstallPermission = function useAppInstallPermission(stargateBaseUrl, product, cloudId) {
  var appInstallPermissionPromise = product && cloudId ? new StargateAPI(stargateBaseUrl).marketplace.appInstallPermission(product, cloudId) : new Promise(function () {});

  var _hooks$usePromise2 = hooks.usePromise(function () {
    return appInstallPermissionPromise;
  }, [product, cloudId], !!(product && cloudId)),
      result = _hooks$usePromise2.result,
      error = _hooks$usePromise2.error,
      pending = _hooks$usePromise2.pending;

  return {
    appInstallPermissionPending: pending,
    appInstallPermissionError: error,
    appInstallPermissionResult: result
  };
};